import { useMemo } from 'react';
import { TenderOffer } from 'types';
import { getMaximumSaleUnits } from '../utils/getMaximumSaleUnits';
import { getSoldAmount } from '../utils/getSoldAmount';
import { getNetAmount } from '../utils/getNetAmount';
import { getSoldUnits } from '../utils/getSoldUnits';
import { getSaleDate } from '../utils/getSaleDate';
import { getParticipantStatus } from '../utils/getParticipantStatus';
import { Eligible } from '../types/Eligible';

const platformDomain = process.env.REACT_APP_DOMAIN;

type UseGetEligiblesProps = {
  eligiblesList: any[];
  societyId: string;
  tenderOffer: TenderOffer;
};

export const useGetEligibles = ({
  eligiblesList,
  societyId,
  tenderOffer,
}: UseGetEligiblesProps) => {
  const eligibles: Eligible[] = useMemo(() => {
    if (!eligiblesList || eligiblesList.length === 0 || !tenderOffer) return [];

    return eligiblesList.map((eligible) => {
      const participant = tenderOffer?.participants.find(
        (p) => p.id === eligible.id
      );

      const linkRoute = eligible.type === 'PARTNER' ? 'socio' : 'beneficiario';
      const maximumSaleUnits = getMaximumSaleUnits({
        eligible,
        tenderOffer,
      });
      const sharePrice = tenderOffer.totalPriceByShare;
      const soldAmount = getSoldAmount({
        participant,
        sharePrice,
      });

      const netAmount = getNetAmount({
        participant,
        sharePrice,
        retentionPercentage: eligible.retentionPercent,
      });

      const soldUnits = getSoldUnits({
        participant,
      });

      const saleDate = getSaleDate({
        participant,
      });

      const status = getParticipantStatus({
        participant,
      });

      return {
        name: eligible.name,
        email: eligible.email,
        totalUnits: eligible.originalUnits,
        link: `/participacion-tender-offer/${societyId}/${tenderOffer?._id}/${linkRoute}/${eligible.id}`,
        platformLink: `${platformDomain}/#/participacion-tender-offer/${societyId}/${tenderOffer?._id}/${linkRoute}/${eligible.id}`,
        maximumSaleUnits,
        ndPercentage: eligible.NDPercent,
        fdPercentage: eligible.FDPercent,
        offerAmount: maximumSaleUnits * sharePrice,
        soldUnits,
        soldAmount,
        strikePrice: eligible.strikePrice,
        retentionPercentage: eligible.retentionPercent,
        netAmount,
        saleDate,
        statusLabel: status.label,
        statusBadge: status.badge,
        isCanceled: eligible.isCanceled,
      };
    });
  }, [eligiblesList, societyId, tenderOffer]);
  return {
    data: { eligibles },
  };
};
